module.exports = __webpack_public_path__ + "img/cuizhixiaozhou.prt.46e27df5.jpg";